import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { sanitizarTexto } from '../utils/sanitizarTexto';

const RESET_URL = `${process.env.REACT_APP_API_URL}/auth/reset-password`;

const IconoOjo = ({ visible }) => {
    if (visible) {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    fill="currentColor"
                    d="M2.1 3.51L3.51 2.1 21.9 20.49 20.49 21.9l-2.16-2.16A11.7 11.7 0 0 1 12 21C6 21 2.73 16.89 1 12c.7-2.02 1.77-3.82 3.13-5.31L2.1 3.51ZM12 7c6 0 9.27 4.11 11 9a15.63 15.63 0 0 1-2.93 4.57l-1.43-1.43A13.47 13.47 0 0 0 21 16c-1.73-4.89-5-9-9-9-1.03 0-2 .22-2.9.6L7.74 6.24C9.05 5.48 10.49 5 12 5c1.77 0 3.4.45 4.86 1.19l-1.45 1.45A6.97 6.97 0 0 0 12 7Zm0 2a4.98 4.98 0 0 1 4.12 2.17l-1.44 1.44A3 3 0 0 0 12 11a3 3 0 0 0-1.61.47L8.94 10.02A4.95 4.95 0 0 1 12 9Zm0 6a3 3 0 0 0 1.53-.42l-3.95-3.95A3 3 0 0 0 12 15Z"
                />
            </svg>
        );
    }

    return (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M12 5c6 0 9.27 4.11 11 9-1.73 4.89-5 9-11 9S2.73 18.89 1 14c1.73-4.89 5-9 11-9Zm0 2c-4 0-7.27 4.11-9 7 1.73 2.89 5 7 9 7s7.27-4.11 9-7c-1.73-2.89-5-7-9-7Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
            />
        </svg>
    );
};

export function ResetPassword() {

    const [email, setEmail] = useState('');
    const [tempPassword, setTempPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');

    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    // Cuando es true, el botón pasa a "Ir a inicio de sesión"
    const [passwordChanged, setPasswordChanged] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const [mostrarTempPassword, setMostrarTempPassword] = useState(false);
    const [mostrarNewPassword, setMostrarNewPassword] = useState(false);
    const [mostrarNewPassword2, setMostrarNewPassword2] = useState(false);

    useEffect(() => {
        try {
            const params = new URLSearchParams(location.search);

            const emailParam = params.get('email') || '';
            const tempParam = params.get('temp_password') || params.get('tempPassword') || '';

            if (emailParam) setEmail(emailParam);
            if (tempParam) setTempPassword(tempParam);
        } catch (e) {
        }
    }, [location.search]);

    const estiloContenedorPassword = {
        position: "relative",
        display: "block"
    };

    const estiloOjo = {
        position: "absolute",
        right: "12px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#666666",
        zIndex: 2
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Si la contraseña ya fue cambiada, el botón ahora navega a login
        if (passwordChanged) {
            navigate('/login');
            return;
        }

        setError(null);
        setMessage(null);

        if (!email || !tempPassword || !newPassword || !newPassword2) {
            setError('Todos los campos son obligatorios.');
            return;
        }

        if (newPassword.length < 8 || newPassword2.length < 8) {
            setError('La nueva contraseña debe contener un mínimo de 8 caracteres.');
            return;
        }

        if (newPassword !== newPassword2) {
            setError('Las contraseñas nuevas no coinciden.');
            return;
        }

        try {
            setLoading(true);

            await axios.post(
                RESET_URL,
                JSON.stringify({
                    email,
                    temp_password: tempPassword,
                    new_password: newPassword
                }),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            setMessage('Tu contraseña fue actualizada correctamente. Ya podés iniciar sesión con la nueva contraseña.');
            setPasswordChanged(true);
        } catch (err) {
            const msg = err?.response?.data?.message || 'Ocurrió un error al actualizar la contraseña.';
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    const getButtonText = () => {
        if (passwordChanged) return 'Ir a inicio de sesión';
        if (loading) return 'Actualizando...';
        return 'Actualizar contraseña';
    };

    return (
        <div className="body-login">
            <div className="row header">
                <div className="col-md-3 d-none d-md-block">
                    <p></p>
                </div>
                <div className="col-md-6 col-sm-12 p-0 logo-container">
                    <img className="logo-cortado" src="/Logo-Ethical.png" />
                </div>
                <div className="col-md-3 d-none d-md-block">
                    <p></p>
                </div>
            </div>

            <div className="row body">
                <div className="col-md-3 d-none d-md-block">
                    <p></p>
                </div>
                <div className="col-md-6 col-sm-12 body-content">
                    <p className="title">Restablecer contraseña</p>

                    <p className="text-muted" style={{ fontSize: '14px' }}>
                        Ingresá el correo con el que iniciás sesión, la contraseña temporal que recibiste por email
                        y la nueva contraseña que querés usar.
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <p className="label">
                                <span><img src="message.png" /></span>
                                <span className="label-text">Correo electrónico</span>
                            </p>
                            <p>
                                <input
                                    className="form-text"
                                    type="email"
                                    name="email"
                                    autoComplete="off"
                                    onChange={(e) => setEmail(sanitizarTexto(e.target.value))}
                                    value={email}
                                    required
                                />
                            </p>
                        </div>

                        <div className="form-group">
                            <p className="label">
                                <span><img src="lock.png" /></span>
                                <span className="label-text">Contraseña temporal</span>
                            </p>

                            <p style={estiloContenedorPassword}>
                                <input
                                    className="form-text"
                                    type={mostrarTempPassword ? "text" : "password"}
                                    name="tempPassword"
                                    autoComplete="off"
                                    onChange={(e) => setTempPassword(e.target.value)}
                                    value={tempPassword}
                                    required
                                    style={{ paddingRight: "44px" }}
                                />

                                <span
                                    role="button"
                                    tabIndex={0}
                                    style={estiloOjo}
                                    onClick={() => { setMostrarTempPassword(!mostrarTempPassword) }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setMostrarTempPassword(!mostrarTempPassword);
                                        }
                                    }}
                                    aria-label={mostrarTempPassword ? "Ocultar contraseña temporal" : "Mostrar contraseña temporal"}
                                    title={mostrarTempPassword ? "Ocultar contraseña temporal" : "Mostrar contraseña temporal"}
                                >
                                    <IconoOjo visible={mostrarTempPassword} />
                                </span>
                            </p>
                        </div>

                        <div className="form-group">
                            <p className="label">
                                <span><img src="lock.png" /></span>
                                <span className="label-text">Nueva contraseña</span>
                            </p>

                            <p style={estiloContenedorPassword}>
                                <input
                                    className="form-text"
                                    type={mostrarNewPassword ? "text" : "password"}
                                    name="newPassword"
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    value={newPassword}
                                    required
                                    minLength={8}
                                    style={{ paddingRight: "44px" }}
                                />

                                <span
                                    role="button"
                                    tabIndex={0}
                                    style={estiloOjo}
                                    onClick={() => { setMostrarNewPassword(!mostrarNewPassword) }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setMostrarNewPassword(!mostrarNewPassword);
                                        }
                                    }}
                                    aria-label={mostrarNewPassword ? "Ocultar nueva contraseña" : "Mostrar nueva contraseña"}
                                    title={mostrarNewPassword ? "Ocultar nueva contraseña" : "Mostrar nueva contraseña"}
                                >
                                    <IconoOjo visible={mostrarNewPassword} />
                                </span>
                            </p>
                        </div>

                        <div className="form-group">
                            <p className="label">
                                <span><img src="lock.png" /></span>
                                <span className="label-text">Repetir nueva contraseña</span>
                            </p>

                            <p style={estiloContenedorPassword}>
                                <input
                                    className="form-text"
                                    type={mostrarNewPassword2 ? "text" : "password"}
                                    name="newPassword2"
                                    onChange={(e) => setNewPassword2(e.target.value)}
                                    value={newPassword2}
                                    required
                                    minLength={8}
                                    style={{ paddingRight: "44px" }}
                                />

                                <span
                                    role="button"
                                    tabIndex={0}
                                    style={estiloOjo}
                                    onClick={() => { setMostrarNewPassword2(!mostrarNewPassword2) }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setMostrarNewPassword2(!mostrarNewPassword2);
                                        }
                                    }}
                                    aria-label={mostrarNewPassword2 ? "Ocultar repetición de contraseña" : "Mostrar repetición de contraseña"}
                                    title={mostrarNewPassword2 ? "Ocultar repetición de contraseña" : "Mostrar repetición de contraseña"}
                                >
                                    <IconoOjo visible={mostrarNewPassword2} />
                                </span>
                            </p>
                        </div>

                        <div className="form-group-actions">
                            <button className="btn-primary" type="submit" disabled={loading}>
                                <p>{getButtonText()}</p>
                            </button>
                        </div>
                    </form>

                    {message && (
                        <p style={{ marginTop: '20px', fontSize: '14px', color: '#28a745', textAlign: 'center' }}>
                            {message}
                        </p>
                    )}

                    {error && (
                        <p style={{ marginTop: '20px', fontSize: '14px', color: 'red', textAlign: 'center' }}>
                            {error}
                        </p>
                    )}
                </div>
                <div className="col-md-3 d-none d-md-block">
                    <p></p>
                </div>
            </div>
        </div>
    );
}